import React from 'react';

import './index.css'

const BackdropMobileMenu = ({ isMenuOpen }) => {
    return isMenuOpen ? <div className="backdrop_mobile_menu"></div> : null;
};

export default BackdropMobileMenu;
